export const regionOptions = [
  {
    label: 'US',
    value: 'us'
  },
  {
    label: 'EU',
    value: 'eu'
  },
  {
    label: 'AU',
    value: 'au'
  }
]
